<script>
export default{
  name: "CondoCard",
  props: {
    condo: {
      type: Object,
      required: true
    }
  },
  methods: {
    handleRoute(){
      this.$router.push({
        name: 'condo_details',
        params: {
          accountId: this.$route.params.accountId,
          condoId: this.condo.condo_id,
        },
      });
    }
  }
}
</script>

<template>
  <div 
    @click="handleRoute"
    class="cursor-pointer relative hover:bg-woot-50 dark:hover:bg-slate-700 bg-white dark:bg-slate-800 overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 rounded-lg border border-slate-200 dark:border-slate-700 flex flex-col group"
  >
    <!-- Image -->
    <div v-if="condo.presigned_image_url" class="h-40 w-full overflow-hidden bg-slate-100 dark:bg-slate-900">
      <img 
        :src="condo.presigned_image_url" 
        :alt="condo.condo_name" 
        class="w-full h-full object-cover"
      />
    </div>
    <div v-else class="h-40 w-full flex items-center justify-center bg-slate-100 dark:bg-slate-900 text-slate-400 dark:text-slate-500">
      <fluent-icon icon="condo" class="h-10 w-10" />
    </div>

    <!-- Card Content -->
    <div class="flex-1 p-4 flex flex-col">
      <!-- Name + Address -->
      <div class="mb-3">
        <h4 
          class="text-base font-medium text-slate-900 dark:text-slate-100 truncate"
          :title="condo.condo_name"
        >
          {{ condo.condo_name }}
        </h4>
        <p class="text-sm text-slate-600 dark:text-slate-400 truncate">
          {{ condo.address }}
        </p>
      </div>

      <!-- Description -->
      <p class="text-sm text-slate-600 dark:text-slate-300 line-clamp-3 flex-1">
        {{ condo.description || 'No description available.' }}
      </p>

      <!-- Actions -->
      <div class="mt-3 pt-2 border-t border-slate-100 dark:border-slate-700 flex gap-4 justify-end opacity-0 group-hover:opacity-100 transition-opacity">
        <woot-button @click.stop="$emit('edit', condo)" icon="edit" size="small">Edit</woot-button>
        <woot-button @click.stop="$emit('delete', condo)" icon="delete" size="small" color-scheme="alert">Delete</woot-button>
      </div>
    </div>
  </div>
</template>